<template>
    <div class="padding-normal">
        <div class="normal-container">
            <h2>{{ title }}</h2>
        </div>
        <div class="w-full overflow-hidden">
            <ProductSlide
                :activeTab="slideData"
                :tabIndex="0"
                :componentId="componentId"
                :showLabels="showLabels"
                :tabs="[slideData]"
                :title="title || ''"
                :desktop-productcard-size="desktopProductcardSize || ''" />
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        title: String,
        dataSource: String,
        pageReference: Object,
        TweakwiseRecommendationId: Number,
        // Sanity _key of this block, passed by the BlockResolver
        componentId: String,
        desktopProductcardSize: String,
        showLabels: {
            type: Boolean,
            default: true,
        },
    });

    const slideData = computed(() => ({
        title: props.title,
        dataSource: props.dataSource,
        pageReference: props.pageReference,
        TweakwiseRecommendationId: props.TweakwiseRecommendationId,
    }));
</script>
